import styled from "@emotion/styled";
import React from "react";

interface AnchorLinkProps {
  children: React.ReactNode;
  href: string;
}

export const AnchorLink = ({ children, href }: AnchorLinkProps) => {
  const StyledLink = styled.a`
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.palette.primary.dark};
    }
  `;

  return (
    <StyledLink target="_top" rel="noopener noreferrer" href={href}>
      {children}
    </StyledLink>
  );
};
